import React, { useEffect, useState } from 'react';
import '../assets/css/multiChipComponent.css';

export default function MultiChipComponent({
  label = '',
  secondaryLabel = false,
  fieldName = '',
  values = [],
  defaultSelected = [],
  onChange = () => { },
  singleSelect = false,
  maxSelection = null, // e.g., 3
  showSelectedValues = false,
  appendDataFn = null
}) {
  const [selectedValues, setSelectedValues] = useState(defaultSelected);

  const toggleValue = (value) => {
    let updated;

    if (singleSelect) {
      // Only one selection allowed
      updated = selectedValues.includes(value) ? [] : [value];
    } else {
      // Multi-select with optional max limit
      const isSelected = selectedValues.includes(value);
      if (isSelected) {
        updated = selectedValues.filter((v) => v !== value);
      } else {
        if (maxSelection && selectedValues.length >= maxSelection) return;
        updated = [...selectedValues, value];
      }
    }

    setSelectedValues(updated);
    onChange(fieldName, updated);
  };

  useEffect(() => {
    setSelectedValues(defaultSelected);
  }, [defaultSelected]);

  return (
    <div className={`form-group ${secondaryLabel && 'secondary-form-group'}`}>
      <div className='head'>
        <label htmlFor='_'>{label}</label>
        {/* FREE MODE: everything is free now, so the PREMIUM badge is hidden —
            {!secondaryLabel && (<span>PREMIUM</span>)} */}
      </div>
      <div className='content'>
        {/* Selected Tags */}
        {(showSelectedValues && selectedValues.length > 0) && (
          <div>
            {selectedValues.map((item) => (
              <div
                key={item}
                className="badge badge-pill badge-theme mr-2 mb-2"
              >
                {item}
                <button
                  type="button"
                  className="ml-1 p-0 btn btn-link text-white"
                  onClick={() => toggleValue(item)}
                >
                  &times;
                </button>
              </div>
            ))}
          </div>
        )}

        <div className="chip-container">
          {values.map((value) => (
            <button
              type='button'
              key={value}
              className={`chip ${selectedValues.includes(value) ? 'selected' : ''}`}
              onClick={() => toggleValue(value)}
            >
              {value}
            </button>
          ))}
        </div>

        {appendDataFn && appendDataFn()}
      </div>
    </div>
  );
}
